module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Water-mixer-3a0ae90d056fd5e000542fb8b913a916.svg";